module.exports = __webpack_public_path__ + "img/TZS09481.d8d728cc.jpeg";